<template>
  <div class="flex_column_evenly pair">
    <div class="flex_row_center">
      <i class="incfont el-icon-title"></i>
      <span lang="OLED" class="margin_left">OLED+震动马达</span>
    </div>

    <div class="flex_row_center">
      <span lang="Width" class="margin_left">宽</span>
      <el-input-number
      v-model="width"
      @change="handleWidthChange"
      :min="0"
      :max="256"
      size="mini">
      </el-input-number>  

      <span lang="Hight" class="margin_left">高</span>
      <el-input-number
      v-model="hight"
      @change="handleHightChange"
      :min="0"
      :max="256"
      size="mini">
      </el-input-number>        
    </div>

    <div class="flex_row_center">
      <el-button @click="handleBlackClick" class="pair_button"><span lang="OLEDBlack">全黑</span></el-button>
      <el-button @click="handleWhiteClick" class="pair_button"><span lang="OLEDWhite">全白</span></el-button>
      <el-button @click="handleBlackWhiteClick" class="pair_button"><span lang="OLEDBlack">黑白</span></el-button>
      <el-button @click="handleSpotClick" class="pair_button"><span lang="OLEDWhite">斑点</span></el-button>  
      <el-button @click="handleRestoreClick" class="pair_button"><span lang="OLEDWhite">显示屏恢复默认</span></el-button>   
      <!-- <el-button @click="handleAudioClick" class="pair_button"><span lang="OLEDWhite">获取当前喇叭的声音</span></el-button>  -->
    </div>

    <div class="flex_row_center">
      <span>震动模式</span>
      <select
        v-model="mode"
        @change="handleModeChange">
        <option 
        v-for="item in modeOptions" 
        :key="item.value" 
        :value="item.value">{{item.option}}</option>
      </select>
    </div>

    <div class="flex_row_center">
      <span>普通震动</span>
      <select
        v-model="normal"
        @change="handleNormalChange">
        <option 
        v-for="item in timesOptions" 
        :key="item.value" 
        :value="item.value">{{item.option}}</option>
      </select>

      <span>加强震动</span>
      <select
        v-model="strength"
        @change="handleStrengthChange">
        <option 
        v-for="item in timesOptions" 
        :key="item.value" 
        :value="item.value">{{item.option}}</option>
      </select>

      <span>爆破震动</span>
      <select
        v-model="burst"
        @change="handleBurstChange">
        <option 
        v-for="item in timesOptions" 
        :key="item.value" 
        :value="item.value">{{item.option}}</option>
      </select>      
    </div>

    <div class="flex_row_center">
      <span>按键</span>
      <select
        v-model="index"
        @change="handleIndexChange">
        <option 
        v-for="item in 6" 
        :key="item - 1" 
        :value="item - 1">{{item}}</option>
      </select>

      <span>震动类型</span>
      <select
        v-model="type"
        @change="handleTypeChange">
        <option 
        v-for="item in typeOptions" 
        :key="item.value" 
        :value="item.value">{{item.option}}</option>
      </select>    
    </div>

    <div class="flex_row_center">
      <el-checkbox 
      v-model="powerOn"
      @change="handlePowerOnChange">
      <span>开机震动使能</span>
      </el-checkbox>

      <el-checkbox 
      v-model="dpiSwitch"
      @change="handleDPISwitchChange">
      <span>DPI切换震动使能</span>
      </el-checkbox>

      <el-checkbox 
      v-model="lowPower"
      @change="handleLowPowerChange">
      <span>低电提示震动使能</span>
      </el-checkbox>

      <el-checkbox 
      v-model="countdown"
      @change="handleCountdownChange">
      <span>倒计时休息震动使能</span>
      </el-checkbox>

      
      <el-button @click="handleMotorClick" class="pair_button"><span lang="OLEDWhite">马达恢复默认</span></el-button>  
    </div>
  
  </div> 
</template>

<script>
import HIDHandle from '@/assets/js/HIDHandle';

  export default {
    data() {
      return {
        width:128,
        hight:80,
        count:1280,
        mode:0,
        levelMax:5,
        timesOptions:[
            {
                value:0,
                option:"20ms",
            },
            {
                value:1,
                option:"30ms",
            },           
            {
                value:2,
                option:"40ms",
            },
            {
                value:3,
                option:"50ms",
            },
            {
                value:4,
                option:"60ms",
            },
            {
                value:5,
                option:"70ms",
            },
            {
                value:6,
                option:"80ms",
            },
            {
                value:7,
                option:"100ms",
            }, 
            {
                value:8,
                option:"150ms",
            },     
            {
                value:9,
                option:"200ms",
            },
            {
                value:10,
                option:"300ms",
            }        
        ],
        modeOptions:[
        {
            value:0,
            option:"关闭震动"
        },
        {
            value:1,
            option:"普通震动"
        },
        {
            value:2,
            option:"加强震动"
        },
        {
            value:3,
            option:"爆破震动"
        }
        ],  
        normal:0,
        strength:0,
        burst:0,
        index:0,
        type:0,
        types:[0,0,0,0,0,0],
        typeOptions:[
        {
            value:0,
            option:"关闭震动"
        },
        {
            value:1,
            option:"短震动"
        },
        {
            value:2,
            option:"长震动"
        }
        ],    
        switches:0,
        powerOn:false,
        dpiSwitch:false,
        lowPower:false,
        countdown:false,
        isCapturing: false,
        errorMsg: '',
        params: null,            // 存储最近一次获取的参数
        // 音频相关
        audioCtx: null,
        mediaStream: null,
        sourceNode: null,
        analyserNode: null,
        // 静默播放器（保持后台运行）
        keepAliveCtx: null,
        keepAliveSource: null,
      }
    },
    methods: {
      handleWidthChange() {
        this.count = this.width * this.hight / 8;
      },
      handleHightChange() {
        this.count = this.width * this.hight / 8;
      },
      async handleBlackClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0x00;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleWhiteClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0xff;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleBlackWhiteClick() {
        var pixel = new Uint8Array(this.count);
        for(var j = 0;j < this.hight;j++) {
          for(var i = 0;i < (this.width / 8);i++) {
            pixel[i] = ((j % 2 == 0 ? 0xff : 0x00));
          }
        }

        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleSpotClick() {
        var pixel = new Uint8Array(this.count);
        for(var i = 0;i < this.count;i++) {
          pixel[i] = 0x55;
        }
        await HIDHandle.Set_Device_OLEDPicture(pixel);
      },
      async handleRestoreClick() {
        await HIDHandle.Restore_Device_OLEDPicture();
      },
      // ---------- 静默播放器（防止最小化卡死） ----------
      setupSilentAudio() {
        if (this.keepAliveCtx) return;
        try {
          this.keepAliveCtx = new (window.AudioContext || window.webkitAudioContext)();
          const buffer = this.keepAliveCtx.createBuffer(1, 1, 22050);
          const source = this.keepAliveCtx.createBufferSource();
          source.buffer = buffer;
          source.loop = true;
          source.connect(this.keepAliveCtx.destination);
          source.start();
          this.keepAliveSource = source;
          if (this.keepAliveCtx.state === 'suspended') {
            this.keepAliveCtx.resume();
          }
          console.log('[静默播放器] 已启动');
        } catch (err) {
          console.warn('[静默播放器] 启动失败', err);
        }
      },
      stopSilentAudio() {
        if (this.keepAliveSource) {
          try { this.keepAliveSource.stop(); } catch(e) {}
          this.keepAliveSource = null;
        }
        if (this.keepAliveCtx) {
          this.keepAliveCtx.close();
          this.keepAliveCtx = null;
        }
      },
      // ---------- 节拍检测：基于历史 RMS 的动态阈值 ----------
      // 输入当前帧的 RMS 值（线性，范围 0~1）
      // 返回 { detected: boolean, strength: number }
      detectBeat(currentRMS) {
        // 维护历史记录
        this.rmsHistory.push(currentRMS);
        if (this.rmsHistory.length > this.historyMaxLen) {
          this.rmsHistory.shift();
        }
        if (this.rmsHistory.length < 10) {
          // 初始未积累足够数据，不判节拍
          return { detected: false, strength: 0 };
        }

        // 计算历史均值与标准差
        let sum = 0;
        for (let val of this.rmsHistory) {
          sum += val;
        }
        const mean = sum / this.rmsHistory.length;
        let sumSq = 0;
        for (let val of this.rmsHistory) {
          sumSq += (val - mean) ** 2;
        }
        const std = Math.sqrt(sumSq / this.rmsHistory.length);

        // 动态阈值 = mean + factor * std
        const threshold = mean + this.beatThresholdFactor * std;
        if (currentRMS > threshold) {
          // 强度：归一化超出量 (currentRMS - threshold) / (1 - threshold)，范围0~1
          let strength = (currentRMS - threshold) / (1 - threshold);
          strength = Math.min(1.0, Math.max(0, strength));
          return { detected: true, strength };
        } else {
          return { detected: false, strength: 0 };
        }
      },

      // ---------- 核心：获取并打印参数 ----------
      logAudioParams() {
        if (!this.isCapturing || !this.analyserNode || !this.audioCtx) return;

        const analyser = this.analyserNode;
        const fftSize = analyser.fftSize;
        const timeArray = new Uint8Array(fftSize);
        const freqArray = new Uint8Array(fftSize / 2);

        analyser.getByteTimeDomainData(timeArray);
        analyser.getByteFrequencyData(freqArray);

        // ----- 1. 振幅计算：RMS（线性）和 dB，以及最大振幅 -----
        let sumSquares = 0;
        let maxSample = 0;
        for (let i = 0; i < fftSize; i++) {
          const v = (timeArray[i] - 128) / 128;
          sumSquares += v * v;
          const absV = Math.abs(v);
          if (absV > maxSample) maxSample = absV;
        }
        const rmsLinear = Math.sqrt(sumSquares / fftSize); // 0~1 之间
        let volumeDB = -100;
        if (rmsLinear > 0.00001) volumeDB = 20 * Math.log10(rmsLinear);
        volumeDB = Math.max(-100, Math.min(0, volumeDB));

        // ----- 2. 频谱：8个频段平均幅度 + 峰值频率 -----
        const nyquist = this.audioCtx.sampleRate / 2;
        const freqResolution = nyquist / (fftSize / 2);
        const numBands = 8;
        const bandSize = Math.floor(freqArray.length / numBands);
        const bandEnergy = new Array(numBands).fill(0);
        let peakMag = -Infinity;
        let peakIdx = 0;
        for (let i = 0; i < freqArray.length; i++) {
          const mag = freqArray[i];
          const bandIndex = Math.floor(i / bandSize);
          if (bandIndex < numBands) bandEnergy[bandIndex] += mag;
          if (mag > peakMag) {
            peakMag = mag;
            peakIdx = i;
          }
        }
        // 平均
        for (let i = 0; i < numBands; i++) {
          bandEnergy[i] = bandEnergy[i] / bandSize;
        }
        const peakFreq = peakIdx * freqResolution;

        // ----- 3. 节拍检测 -----
        const beat = this.detectBeat(rmsLinear);

        if(volumeDB > -100) {
          // ----- 打印到控制台 -----
          console.log({
            timestamp: Date.now(),
            amplitude: {
              rms_dB: volumeDB.toFixed(2),
              max_amplitude: maxSample.toFixed(4),
              rms_linear: rmsLinear.toFixed(4),
            },
            spectrum: {
              bands_8: bandEnergy.map(v => Math.round(v)), // 0-255 整数
              peak_freq_Hz: peakFreq.toFixed(1),
            },
            beat: {
              detected: beat.detected,
              strength: beat.strength.toFixed(3),
            },
          });
        }
      },
      // ---------- 开始捕获系统音频 ----------
      async handleAudioClick() {
        this.errorMsg = '';
        if (!navigator.mediaDevices || !navigator.mediaDevices.getDisplayMedia) {
          this.errorMsg = '浏览器不支持 getDisplayMedia，无法捕获系统音频。';
          return;
        }

        this.setupSilentAudio();

        try {
          const stream = await navigator.mediaDevices.getDisplayMedia({
            video: true,
            audio: {
              systemAudio: 'include',
              suppressLocalAudioPlayback: false,
            },
            selfBrowserSurface: 'include',
          });

          const audioTrack = stream.getAudioTracks()[0];
          if (!audioTrack) {
            throw new Error('未捕获到系统音频，请勾选“共享音频”');
          }

          this.mediaStream = stream;

          // 创建用于分析的 AudioContext
          if (this.audioCtx && this.audioCtx.state !== 'closed') {
            await this.audioCtx.close();
          }
          this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          this.sourceNode = this.audioCtx.createMediaStreamSource(stream);
          this.analyserNode = this.audioCtx.createAnalyser();
          this.analyserNode.fftSize = 2048;
          this.analyserNode.smoothingTimeConstant = 0.8;
          this.sourceNode.connect(this.analyserNode);
          // 不连接 destination，避免播放出来

          if (this.audioCtx.state === 'suspended') {
            await this.audioCtx.resume();
          }

          this.isCapturing = true;
          
          // 重置节拍历史缓冲区
          this.rmsHistory = [];

          // 启动定时打印，每 200ms 打印一次（可根据需要调整频率）
          this.intervalId = setInterval(() => {
            this.logAudioParams();
          }, 200);

          // 监听共享结束事件
          const videoTrack = stream.getVideoTracks()[0];
          if (videoTrack) {
            videoTrack.addEventListener('ended', () => {
              this.stopCapture();
            });
          }
        } catch (err) {
          console.error(err);
          this.errorMsg = `捕获失败: ${err.message}`;
          this.stopCapture();
        }
      },
      // ---------- 停止捕获 ----------
      stopCapture() {
        if (this.audioCtx) {
          this.audioCtx.close().catch(e => console.warn);
          this.audioCtx = null;
        }
        if (this.mediaStream) {
          this.mediaStream.getTracks().forEach(track => track.stop());
          this.mediaStream = null;
        }
        this.isCapturing = false;
        this.params = null;
        // 可根据需要决定是否停止静默播放器（这里保留，便于快速重新开始）
        // this.stopSilentAudio();
      },

      // ---------- 核心：获取当前音频参数（瞬时值） ----------
      getAudioParams() {
        if (!this.isCapturing || !this.analyserNode) {
          this.errorMsg = '请先点击“开始捕获系统音频”。';
          return;
        }

        const analyser = this.analyserNode;
        const fftSize = analyser.fftSize;
        const timeArray = new Uint8Array(fftSize);
        const freqArray = new Uint8Array(fftSize / 2);

        analyser.getByteTimeDomainData(timeArray);   // 时域
        analyser.getByteFrequencyData(freqArray);    // 频域

        // ---- 1. 计算音量 (dB RMS) 和最大振幅 ----
        let sumSquares = 0;
        let maxSample = 0;
        for (let i = 0; i < fftSize; i++) {
          const v = (timeArray[i] - 128) / 128;
          sumSquares += v * v;
          const absV = Math.abs(v);
          if (absV > maxSample) maxSample = absV;
        }
        const rms = Math.sqrt(sumSquares / fftSize);
        let volumeDB = -100;
        if (rms > 0.00001) volumeDB = 20 * Math.log10(rms);
        volumeDB = Math.max(-100, Math.min(0, volumeDB));

        // ---- 2. 计算频谱峰值 (频率 + 幅度) ----
        const nyquist = this.audioCtx.sampleRate / 2;
        const freqResolution = nyquist / (fftSize / 2);
        let maxMag = -Infinity;
        let maxMagIndex = 0;
        for (let i = 0; i < freqArray.length; i++) {
          const mag = freqArray[i];
          if (mag > maxMag) {
            maxMag = mag;
            maxMagIndex = i;
          }
        }
        const peakFreq = maxMagIndex * freqResolution;
        const peakMagnitude = maxMag;  // 原始 0-255 值

        // 保存结果
        this.params = {
          volumeDB,
          maxAmplitude: maxSample,
          peakFreq,
          peakMagnitude,
        };

        if(volumeDB > -100)
          console.log("params:",this.params);
      },
      async handleModeChange() {
        await HIDHandle.Set_Device_MotorMode(this.mode);
      },
      async handleNormalChange() {
        await HIDHandle.Set_Device_MotorLevel(0,this.normal);
      },
      async handleStrengthChange() {
        await HIDHandle.Set_Device_MotorLevel(1,this.strength);
      },
      async handleBurstChange() {
        await HIDHandle.Set_Device_MotorLevel(2,this.burst);
      },
      async handleIndexChange() {
        this.type = this.types[this.index];
      },
      async handleTypeChange() {
        await HIDHandle.Set_Device_MotorButton(this.index,this.type);
        this.types[this.index] = this.type;
      },
      async setSwitches() {
        await HIDHandle.Set_Device_MotorSwitches(this.switches);
      },
      async handlePowerOnChange() {
        if(this.powerOn) {
          this.switches |= 0x01;
        }
        else {
          this.switches &= 0xfe;
        }
        await this.setSwitches();
      },
      async handleDPISwitchChange() {
        if(this.dpiSwitch) {
          this.switches |= 0x02;
        }
        else {
          this.switches &= 0xfd;
        }
        await this.setSwitches();
      },
      async handleLowPowerChange() {
        if(this.lowPower) {
          this.switches |= 0x04;
        }
        else {
          this.switches &= 0xfb;
        }  
        await this.setSwitches();      
      },
      async handleCountdownChange() {
        if(this.countdown) {
          this.switches |= 0x08;
        }
        else {
          this.switches &= 0xf7;
        } 
        await this.setSwitches();       
      },
      async handleMotorClick() {
        await HIDHandle.Restore_Device_MotorParam();//恢复默认
        await HIDHandle.Get_Device_MotorParam();//恢复默认之后再读取一次
        this.updateMotor(HIDHandle.deviceInfo.mouseCfg);
      },
      updateMotor(value) {
        this.mode = value.motor.mode;
        this.normal = value.motor.levels[0];
        this.strength = value.motor.levels[1];
        this.burst = value.motor.levels[2];

        this.index = 0;
        this.type = value.motor.buttons[0];

        for(var i = 0;i < 6;i++) {
          this.types[i] = value.motor.buttons[i];
        }

        this.switches = value.motor.switches;
        this.powerOn = ((this.switches & 0x01) == 0x01);
        this.dpiSwitch = ((this.switches & 0x02) == 0x02);
        this.lowPower = ((this.switches & 0x04) == 0x04);
        this.countdown = ((this.switches & 0x08) == 0x08); 
        
        console.log("111111111111111 updatemotor",value);
      },
      audioResume() {
        document.addEventListener("visibilitychange", async () => {
          console.log("visibilitychange",this.audioCtx);
           if(this.audioCtx != null){
            await this.audioCtx.resume();
            console.log("AudioContext 已恢复");
          }
        });
      },
      getUserAgent() {
        console.log("user agent:",navigator.userAgent);
      }
    },
    created() {
      this.$bus.$on("updateMouseUI",value => {
        this.updateMotor(value);     
      });

      // this.audioResume();
      this.getUserAgent();
    },
  }
</script>

<style lang="less" scoped>

</style>